import { normalizeSvgForTheme } from '@/components/cm-svg-icon/svg-theme'

/** 与 CmSvgIcon 相同的运行时加载方式：raw-loader 直接读取 src/ 下的 .svg 源文件 */
const svgModules = require.context('!raw-loader!../', true, /\.svg$/)

function getSvgRaw (name: string): string | undefined {
  try {
    const mod = svgModules(`./${name}.svg`)
    return typeof mod === 'string' ? mod : (mod && mod.default)
  } catch {
    return undefined
  }
}

const cache = new Map<string, string>()

/** 单色 data-url 的 SVG 根上追加标记 class，供深色模式下 CSS 按 src 子串匹配反白（见 dark-mode.css） */
function markDataUrlMono (svg: string): string {
  return svg.replace(/<svg/i, '<svg class="cm-svg-data-url--mono"')
}

/** 供 el-empty、G6 image、仍使用 img src 的场景 */
export function getSvgIconDataUrl (name: string, monochrome = false): string {
  const cacheKey = `${name}:${monochrome ? 1 : 0}`
  const hit = cache.get(cacheKey)
  if (hit) return hit

  const raw = getSvgRaw(name)
  if (!raw) return ''

  let svg = normalizeSvgForTheme(raw, { monochrome })
  if (monochrome) {
    svg = markDataUrlMono(svg)
  }
  const url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
  cache.set(cacheKey, url)
  return url
}
